<script setup>
// Cabeçalho das telas do painel "Ações do cliente": voltar, título e ações.
defineProps({
  title: { type: String, required: true },
});

const emit = defineEmits(['back']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="flex items-center gap-1.5">
    <button
      type="button"
      class="flex items-center justify-center rounded-lg size-7 shrink-0 text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12"
      title="Voltar"
      aria-label="Voltar"
      @click="emit('back')"
    >
      <span class="size-4 i-lucide-arrow-left" />
    </button>
    <span class="flex-1 min-w-0 text-sm font-semibold truncate text-n-slate-12">
      {{ title }}
    </span>
    <slot />
  </div>
</template>
